module.exports = __webpack_public_path__ + "static/media/Comm_Rest_4.86bc3eb7.gif";